import { Mail, Phone, MapPin, Instagram, Facebook, Twitter } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-card border-t border-border">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <img src="https://res.cloudinary.com/drc2niu3q/image/upload/f_auto,q_auto,w_100/v1764326396/curious-mug-logo_aslp3n.png" alt="Curious Mug - Best Restaurant & Bar in Greater Noida" className="h-10 w-10" />
              <span className="text-xl font-bold text-foreground">Curious Mug</span>
            </div>
            <p className="text-sm text-muted-foreground">
              Best restaurant & bar in Greater Noida, Noida Extension. Experience premium cocktails and exquisite cuisine at Sector 1, Greater Noida West.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold text-foreground mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a href="/" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Home
                </a>
              </li>
              <li>
                <a href="/menu" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Menu
                </a>
              </li>
              <li>
                <a href="/about" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  About
                </a>
              </li>
              <li>
                <a href="/contact" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Contact
                </a>
              </li>
              <li>
                <a href="/blogs" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Blog
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold text-foreground mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-center space-x-2 text-sm text-muted-foreground">
                <Phone size={16} className="text-primary" />
                <span>+91 8448133897</span>
              </li>
              <li className="flex items-center space-x-2 text-sm text-muted-foreground">
                <Mail size={16} className="text-primary" />
                <span>curiousmugnoida@gmail.com</span>
              </li>
              <li className="flex items-start space-x-2 text-sm text-muted-foreground">
                <MapPin size={16} className="text-primary mt-0.5" />
                <span>Curious Mug is located at Shop No 1, Rise Palm Street, Sector 1, Greater Noida, Uttar Pradesh 201318</span>
              </li>
            </ul>
          </div>

          {/* Hours & Social */}
          <div>
            <h3 className="text-lg font-semibold text-foreground mb-4">Hours</h3>
            <p className="text-sm text-muted-foreground mb-4">
              Mon-Sun: 12:00 PM - 11:30 PM<br />
              <span className="text-primary font-semibold">Happy Hours Wednesday</span><br />
              5 PM - 8 PM (30% off)
            </p>
            <div className="flex space-x-4">
              <a href="https://www.instagram.com/curiousmug" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Instagram">
                <Instagram size={20} />
              </a>
              <a href="https://www.facebook.com/curiousmug/" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Facebook">
                <Facebook size={20} />
              </a>
              <a href="https://x.com/thecuriousmug" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Twitter">
                <Twitter size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-border mt-8 pt-8 space-y-3">
          <p className="text-center text-sm text-muted-foreground">
            <strong className="text-foreground">Curious Mug</strong> - Best Restaurant & Bar in Greater Noida | Noida Extension | Greater Noida West
          </p>
          <p className="text-center text-xs text-muted-foreground">
            Shop No 1, Rise Palm Street, Sector 1, Greater Noida, Uttar Pradesh 201318
          </p>
          <p className="text-center text-sm text-muted-foreground">
            © {new Date().getFullYear()} Curious Mug. All rights reserved.
          </p>
          <p className="text-center text-xs text-muted-foreground">
            Powered by{" "}
            <a
              href="https://scaleyourbusiness.online"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary hover:text-accent transition-colors"
            >
              Scale Your Business
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
